/*
  The Fabric Co customizations: "Sample" variants and minimum order quantity.

  Kept out of the theme's own files on purpose. When updating the Local theme, carry over
  this file, custom-fabricco.css and the small hooks marked "Fabric Co" in:
  layout/theme.liquid, snippets/product-quantity.liquid, snippets/product-badges.liquid,
  snippets/cart-form.liquid, snippets/cart-form-page.liquid, sections/main-product.liquid,
  snippets/product-price.liquid, sections/header.liquid, snippets/head-preloader.liquid,
  plus sections/Custom-productpage-tabs.liquid, the Rapid Search snippets/templates,
  "max_blocks": 50 in sections/collection-list.liquid (stock is 15, old theme had 100; brand/subcategory
  templates have up to 32 collections) and the "Check Out" text in locales/en.default.json.

  - Selecting the "Sample" variant hides the quantity box and forces quantity 1.
  - A sample that is already in the cart can't be added again (button greyed out).
  - Other variants start at, and can't go below, the custom.magento_product_min_qty metafield
    (rendered as data-minqty on the quantity selector).
*/
(() => {

	const cartVariantIds = new Set();
	const currentVariants = new WeakMap();

	const isSample = variant => !!variant && String(variant.title || '').toLowerCase() === 'sample';

	const getParts = form => {
		const qty = form && form.querySelector('[data-js-product-quantity]');
		const button = form && form.querySelector('[data-js-product-add-to-cart]');
		if ( ! qty || ! button ) return null;
		return { qty, button, input: qty.querySelector('input'), minQty: parseInt(qty.dataset.minqty) || 1 };
	};

	const getError = form => {
		const root = form.closest('[data-js-product-component]') || form.parentElement;
		let error = root.querySelector('.custom-error');
		if ( ! error ) {
			error = document.createElement('div');
			error.className = 'custom-error';
			(form.closest('product-form') || form).before(error);
		}
		return error;
	};

	const setError = (form, message) => {
		const error = getError(form);
		error.textContent = message || '';
		error.classList.toggle('custom-error__active', !!message);
	};

	const applyVariant = (form, variant) => {
		const parts = getParts(form);
		if ( ! parts ) return;
		const { qty, button, input, minQty } = parts;
		currentVariants.set(form, variant);

		if ( isSample(variant) ) {
			input.min = 1;
			input.value = 1;
			qty.style.display = 'none';
			button.classList.add('sample');
			button.classList.toggle('sampleincart', cartVariantIds.has(Number(variant.id)));
		} else {
			input.min = minQty;
			input.value = minQty;
			button.classList.remove('sample', 'sampleincart');
		}
		setError(form, '');
		input.dispatchEvent(new Event('change', { bubbles: true }));
	};

	// returns false (and shows the message) when the quantity is below the minimum
	const validate = form => {
		const parts = getParts(form);
		if ( ! parts ) return true;
		const { button, input, minQty } = parts;
		const variant = currentVariants.get(form);

		if ( isSample(variant) ) {
			return ! button.classList.contains('sampleincart');
		}
		if ( (parseInt(input.value) || 0) < minQty ) {
			setError(form, `Qty should be equal to or greater than ${minQty}`);
			button.classList.add('disabled');
			return false;
		}
		setError(form, '');
		if ( ! variant || variant.available !== false ) button.classList.remove('disabled');
		return true;
	};

	const initForms = () => {
		document.querySelectorAll('product-variants[data-id]').forEach(el => {
			const form = document.getElementById(`product-form-${el.dataset.id}`);
			if ( ! form ) return;
			let variant = el.currentVariant;
			if ( variant === undefined ) {
				const data = el.querySelector('[data-js-variant-data]');
				try { variant = data ? JSON.parse(data.textContent) : null; } catch (e) { variant = null; }
			}
			if ( variant ) applyVariant(form, variant);
		});
	};

	const refreshCartState = () => fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`)
		.then(response => response.json())
		.then(cart => {
			cartVariantIds.clear();
			cart.items.forEach(item => cartVariantIds.add(Number(item.variant_id)));
			initForms();
		})
		.catch(() => {});

	document.addEventListener('krown:variant:change', e => {
		if ( e.detail && e.detail.productForm ) applyVariant(e.detail.productForm, e.detail.variant);
	});

	document.addEventListener('krown:cart:add', e => {
		if ( ! e.detail ) return;
		cartVariantIds.add(Number(e.detail.variantId));
		const form = e.detail.productForm;
		const variant = form && currentVariants.get(form);
		if ( isSample(variant) ) getParts(form).button.classList.add('sampleincart');
	});

	document.addEventListener('krown:cart:update', refreshCartState);

	document.addEventListener('change', e => {
		if ( e.isTrusted && e.target.matches('[data-js-product-quantity] input') ) {
			const form = e.target.closest('form');
			if ( form ) validate(form);
		}
	});

	// capture phase, so this runs before the theme's own add-to-cart handler
	document.addEventListener('submit', e => {
		if ( ! validate(e.target) ) {
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	}, true);

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', refreshCartState);
	} else {
		refreshCartState();
	}

})();
